import React, { useRef } from 'react';
import { Text } from 'src/@vymo/ui/atoms';
import { Accordion } from 'src/@vymo/ui/blocks';
import Form from 'src/@vymo/ui/molecules/form';
import { FormVersion } from 'src/@vymo/ui/molecules/form/types';
import classnames from 'classnames';
import { ReactComponent as VymoAppIcon } from 'src/assets/icons/vymoAppIcon.svg';
import { mapInputsToFormValues, processTimeStamp } from './queries';
import { HistoryProps } from './types';
import styles from './index.module.scss';

function History({
  data,
  open,
  viewType = 'default',
  classNames,
}: HistoryProps) {
  const { date, timestamp, history, action_type: actionType } = data;
  const { formattedTime, formattedDate } = processTimeStamp(date || timestamp);
  const formRef = useRef(null);
  return (
    <Accordion
      title={
        <div className={classnames(styles.history, classNames)}>
          <div className={styles.history__timeHeader}>
            <Text type="h5">{formattedDate}</Text>
            <Text type="label">{formattedTime}</Text>
          </div>
          <Text type="h6">{actionType}</Text>
          <VymoAppIcon className={styles.history__icon} />
        </div>
      }
      open={open}
      border={false}
    >
      <div className={styles.history__wrapper}>
        {history.map((input) =>
          viewType === 'form' ? (
            <Form
              ref={formRef}
              id="auditCardForm"
              name="auditCardForm"
              span="1fr 1fr"
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              onChange={(formFields) => {}}
              config={{
                version: FormVersion.webRevyre,
                data: input?.config,
                grouping: [],
                fieldItemConfig: {
                  showDisabledIcon: true,
                },
                viewMode: true,
              }}
              value={mapInputsToFormValues(input?.payload)}
            />
          ) : (
            <div className={styles.history__wrapper__item}>
              <Text type="label">{input.name}</Text>
              <Text>{input.value}</Text>
            </div>
          ),
        )}
      </div>
    </Accordion>
  );
}

export default History;
